import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="bg-graphite px-3 py-4 sm:px-6" data-id="element-19" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-2xl" data-id="element-20" data-mp="pj6de6xdyos2">
        <h2 className="text-center font-display text-[1.45rem] font-extrabold uppercase leading-none text-white sm:text-[2rem]" data-id="element-21" data-mp="avcw8hsnje7d">
          5 PREMIUM <span className="text-hazard" data-id="element-22" data-mp="fsv8ah1yu9jl">BONUSES INCLUDED</span>
        </h2>
        <div className="mt-2 space-y-2" data-id="element-23" data-mp="1u5bz3mz0dwa">
          {bonuses.map(bonus => <article key={bonus.number} className="rounded-md border border-line border-l-4 border-l-hazard bg-ink px-2.5 py-2" data-id="element-24" data-mp="5vqlcf0aqa1q">
              <h3 className="font-display text-[0.68rem] font-extrabold uppercase leading-tight text-hazard sm:text-[0.86rem]" data-id="element-25" data-mp="3o2n3bwrgy2il">
                🎁 BONUS {bonus.number} — {bonus.title}
              </h3>
              <p className="mt-0.5 text-[0.78rem] leading-[1.35] text-steel sm:text-[0.92rem]" data-id="element-26" data-mp="1mb9zzc55g2on">{bonus.body}</p>
            </article>)}
        </div>
      </div>
    </section>;
}